module.exports = __webpack_public_path__ + "static/marriage-rules-50dd2affd09aafd9e6c742212bb2eb7f.jpg";